import React from 'react';
import clsx from 'clsx';
import { makeStyles, Drawer, Button, IconButton, Grid} from '@material-ui/core';
import CloseIcon from "@material-ui/icons/Close";


const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
});


/**
 * This function will display some content at bottom
 * @param menuItem      {component} : button's value that will display content at bottom
 * @param component     {component} : the component that will be displayed on click
 * @return {*}
 * @constructor
 */
export default function TemporaryDrawer({ menuItem, component}) {
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <div className={clsx(classes.list, {[classes.fullList]: anchor === 'top' || anchor === 'bottom',})}
             role="presentation">
            <IconButton onClick={toggleDrawer("bottom", false)}>
                <CloseIcon/>
            </IconButton>

            <Grid item xs={12}>
                {component}
            </Grid>
        </div>
    );

    return (
        <Grid style={{width:"100%", flex:1}}>
            <Button style={{width:"100%", flex:1, display:"flex", justifyContent:"flex-start"}}
                    onClick={toggleDrawer("bottom", true)}>
                {menuItem}
            </Button>
            <Drawer anchor={"bottom"} open={state["bottom"]} onClose={toggleDrawer("bottom", false)}>
                {list("bottom")}
            </Drawer>
        </Grid>
    )
}
